module.exports = __webpack_public_path__ + "static/media/google.f971c12e.svg";